import React from 'react';
import HeaderOne from '../../common/header/HeaderOne';
import Banner from '../../components/section-components/Banner';
import ServicesTwo from '../../components/section-components/ServicesTwo';
import AboutTwo from '../../components/section-components/AboutTwo';
import ProjectsOne from '../../components/section-components/ProjectsOne';
import TestimonialOne from '../../components/section-components/TestimonialOne';
import Pricing from '../../components/section-components/Pricing';
import TeamTwo from '../../components/section-components/TeamTwo';
import Counter from '../../components/section-components/Counter';
import NewsTwo from '../../components/section-components/NewsTwo';
import FooterOne from '../../common/footer/FooterOne';

const HomeTwo = () => {
    return (
        <>
        <HeaderOne />
        
        <Banner />
        
        <ServicesTwo />
        
        <AboutTwo />
        
        <ProjectsOne />
        
        <TestimonialOne />
        
        <Pricing />
        
        <TeamTwo />
        
        <Counter />
        
        <NewsTwo />

        <FooterOne />
        </>
    )
}
    
export default HomeTwo;